import React, { useEffect, useState } from "react";
import eyeIcon from "../../../../Assets/icons/eye 1.svg";
import download from "../../../../Assets/icons/download.svg";
import pdfFile from "../../../../Assets/pdffile/Dealership and Service Manual.pdf";
import pdfViewOne from "../../../../Assets/icons/PdfViewone.png";
import pdfViewTwo from "../../../../Assets/icons/PdfViewTwo.png";
import pdfViewThree from "../../../../Assets/icons/PdfViewthree.png";
import pdfViewFour from "../../../../Assets/icons/PdfViewFour.png";
import pdfViewFive from "../../../../Assets/icons/PdfViewFive.png";
import pdfViewSix from "../../../../Assets/icons/PdfViewSix.png";
import "./PolicyMaster.scss";
import axiosInstance from "../../../../http.common";

const PolicyMaster = () => {
  const [selectedPage, setSelectedPage] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [zoomLevel, setZoomLevel] = useState(1);
  const [agreementImage, setAgreementImage] = useState(null);
  const [agreementFile, setAgreementFile] = useState(null);



  const dealerId = localStorage.getItem("dealerId");
  const token = localStorage.getItem("authToken");

  const pdfImages = [
    pdfViewOne,
    pdfViewTwo,
    pdfViewThree,
    pdfViewFour,
    pdfViewFive,
    pdfViewSix,
  ];

  const handleViewPDF = () => {
    window.open(pdfFile, "_blank");
  };

  const handlePageSelect = (e) => {
    const pageNumber = Number(e.target.value);
    setSelectedPage(pageNumber);
    if (pageNumber) setModalIsOpen(true);
  };

  const handleZoomIn = () => {
    setZoomLevel((prevZoom) => Math.min(prevZoom + 0.2, 3)); // Max zoom 3x
  };

  const handleZoomOut = () => {
    setZoomLevel((prevZoom) => Math.max(prevZoom - 0.2, 0.5)); // Min zoom 0.5x
  };

  useEffect(() => {
    fetchPolicyList();
  }, []);

  const fetchPolicyList = async () => {
  try {
    const response = await axiosInstance.get(
      `/dealer/dealerAgreement/${dealerId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const dealerAgreement =
      response?.data?.data?.dealerAgrrement;

    setAgreementFile(dealerAgreement);
  } catch (error) {
    console.log(error);
  }
};

  const isPdf = (url) => {
  return url?.toLowerCase().endsWith(".pdf");
};

  return (
    <div>
      <div className="OnboardManagamentContainer">
        <div
          style={{ width: "100%" }}
          className="OnboardManagamentbuttonContainer col-md-3 mt-2 mb-2"
        >
          <div
            style={{
              lineHeight: "1px",
              display: "flex",
              flexDirection: "column",
              paddingTop: "30px",
            }}
          >
            <p className="ServiceBreadcrumbs">Home / Dealership Agreement</p>
            <h5 style={{ fontWeight: "600" }} className="checkWarrantyHeading">
              Dealership Agreement
            </h5>
          </div>
        </div>
      </div>

      {agreementFile && (
        <div style={{ marginTop: "20px", display:"flex", justifyContent:"center", flexDirection:"column" }}>
          {isPdf(agreementFile) ? (
            <>
              {/* PDF Preview */}
              <iframe
                src={agreementFile}
                title="Dealership Agreement PDF"
                width="100%"
                height="500px"
                style={{
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                }}
              />

              {/* Download Button */}
              <a
                href={agreementFile}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  marginTop: "10px",
                  display: "inline-block",
                  color: "#0d6efd",
                  fontWeight: "500",
                }}
              >
                Download Agreement PDF
              </a>
            </>
          ) : (
            <>
              {/* Image Preview */}
              <img
                src={agreementFile}
                alt="Dealership Agreement"
                style={{
                  width: "100%",
                  maxWidth: "400px",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                }}
              />

              {/* Download Image */}
              <a
                href={agreementFile}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  marginTop: "10px",
                  display: "inline-block",
                  color: "#0d6efd",
                  fontWeight: "500",
                }}
              >
                Download Agreement
              </a>
            </>
          )}
        </div>
      )}
{/* 
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              gap: "15px",
            }}
          >
            <select
              id="number_id"
              value={selectedPage || ""}
              onChange={handlePageSelect}
              style={{
                padding: "16px",
                marginBottom: "10px",
                width: "14rem",
                border: "1px solid black",
                borderRadius: "12px",
                appearance: "none", // Removes default styling
                background: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="black" d="M7 10l5 5 5-5z"/></svg>') no-repeat right 10px center`,
                backgroundColor: "white",
                backgroundSize: "18px",
              }}
            >
              <option value="">Select a Page No.</option>
              {pdfImages.map((_, index) => (
                <option
                  key={index}
                  value={index + 1}
                >{`Page ${index + 1}`}</option>
              ))}
            </select>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "25px",
              }}
            >
              <img
                src={download}
                alt="view PDF"
                style={{ cursor: "pointer", paddingBottom: "10px" }}
                className="eyeIconStyle"
                onClick={handleViewPDF}
              />
            </div>
          </div> */}

      {/* <div className="tableWrapper">
        <div className="filterView"></div>

        <div
          style={{
            paddingTop: "20px",
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            alignItems: "center",
            gap: "10px",
          }}
        >
          {pdfImages.map((src, index) => (
            <img
              key={index}
              id={`page-${index + 1}`}
              src={src}
              alt={`Page ${index + 1}`}
              style={{
                height: "35rem",
                width: "auto",
                transition: "transform 0.3s ease-in-out",
                // transform: selectedPage === index + 1 ? "scale(1.2)" : "scale(1)",
                border: selectedPage === index + 1 ? "2px solid blue" : "none",
                cursor: "pointer",
              }}
              onClick={() => {
                setSelectedPage(index + 1);
                setModalIsOpen(true);
              }}
            />
          ))}
        </div>
      </div> */}

      {/* {modalIsOpen && selectedPage && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            backdropFilter: "blur(10px)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            zIndex: "100",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "15px",
              marginBottom: "10px",
              position: "fixed",
              right: "4rem",
              bottom: "3rem",
            }}
          >
            <button
              onClick={handleZoomIn}
              style={{
                padding: "10px 15px",
                fontSize: "14px",
                cursor: "pointer",
                backgroundColor: "#fff",
                border: "none",
                borderRadius: "5px",
              }}
            >
              ➕
            </button>
            <button
              onClick={handleZoomOut}
              style={{
                padding: "10px 15px",
                fontSize: "14px",
                cursor: "pointer",
                backgroundColor: "#fff",
                border: "none",
                borderRadius: "5px",
              }}
            >
              ➖
            </button>
            <button
              onClick={() => setModalIsOpen(false)}
              style={{
                padding: "10px 15px",
                fontSize: "16px",
                cursor: "pointer",
                backgroundColor: "#ff4d4d",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
              }}
            >
              ✖ Close
            </button>
          </div>
          <img
            src={pdfImages[selectedPage - 1]}
            alt={`Page ${selectedPage}`}
            style={{
              transform: `scale(${zoomLevel})`,
              transition: "transform 0.3s ease-in-out",
            }}
            className="policyMaster-zoomin-image"
          />
        </div>
      )} */}
    </div>
  );
};

export default PolicyMaster;
